<template>
  <PageSkeletonTwo>
    <template slot="header-left">
      <el-input v-model="parameter.fileName" clearable size="medium" placeholder="文件名称" @change="getDocumentaryFileList" />

      <el-input v-model="parameter.email" clearable size="medium" placeholder="客户邮箱" @change="getDocumentaryFileList" />
    </template>

    <template slot="header-right">
      <el-button size="medium" round @click="handleUploadImages">图片素材</el-button>

      <el-button size="medium" round @click="handleUploadNewFile">上传新文件</el-button>
    </template>

    <template slot="container">
      <el-table row-key="id" :data="documentarys" v-loading="loading" style="width: 100%">
        <el-table-column label="文件ID" prop="fileId" fixed="left" />
        <el-table-column label="文件名称" prop="fileName" />
        <el-table-column label="客户邮箱" prop="email" />
        <el-table-column label="最近更新人" prop="modifier" />
        <el-table-column label="最近更新时间">
          <template v-slot="{ row }">
            {{ defaultTips(formatTimeStamp(row.modifyDate)) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="208">
          <template v-slot="{ row }">
            <a href="javascript:;" @click="() => updateFile(row)">更新文件</a>
            <span class="vertical ">|</span>
            <a href="javascript:;" @click="() => seeFile(row.id)">查看</a>
            <span class="vertical ">|</span>
            <a href="javascript:;" @click="() => downloadFile(row.fileUrl)">下载</a>
            <span class="vertical ">|</span>
            <a href="javascript:;" @click="() => deleteFile(row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template #footer-right>
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="sizeChange" @current-change="currentChange" />
    </template>

    <!-- 上传图片素材对话框 -->
    <UploadImagesDialog ref="uploadImagesDialog" />
    <!-- 上传新文件或者更新文件对话框 -->
    <AddOrUpdateFileDialog ref="addOrUpdateFileDialog" @update="getDocumentaryFileList" />
  </PageSkeletonTwo>
</template>

<script>
import API from '@/api'
import { formatTimeStamp } from '@/utils/moment'
import PageSkeletonTwo from '@/components/PageSkeletonTwo.vue'
import UploadImagesDialog from './components/UploadImagesDialog.vue'
import AddOrUpdateFileDialog from './components/AddOrUpdateFileDialog.vue'

let parameter = {
  fileName: undefined,
  email: undefined,
  pageSize: 20,
  pageNumber: 1
}

export default {
  name: 'service_documentary',
  components: {
    PageSkeletonTwo,
    UploadImagesDialog,
    AddOrUpdateFileDialog
  },
  data() {
    return {
      formatTimeStamp,

      parameter: { ...parameter },

      documentarys: [],
      total: 0,
      loading: false
    }
  },
  computed: {
    defaultTips() {
      return (value) => value || '-'
    }
  },
  created() {
    this.getDocumentaryFileList()
  },
  methods: {
    /**
     * API 获取跟单文件列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getDocumentaryFileList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let query = { ...this.parameter }
        let { data } = await API.getDocumentaryFileList(query)
        this.total = data.total
        this.documentarys = data.list
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 上传图片素材
     */
    handleUploadImages() {
      this.$refs.uploadImagesDialog.show()
    },

    /**
     * 上传新文件
     */
    handleUploadNewFile() {
      this.$refs.addOrUpdateFileDialog.show()
    },

    /**
     * 更新文件
     *
     * @param {Object} row 当前行对象
     */
    updateFile(row) {
      this.$refs.addOrUpdateFileDialog.show({ ...row })
    },

    /**
     * 查看文件
     *
     * @param {Number} id 文件ID
     */
    seeFile(id) {
      this.$router.push({
        path: '/service/documentary/detail',
        query: { id }
      })
    },

    /**
     * 下载文件
     *
     * @param {String} fileUrl 是否重置分页
     */
    downloadFile(fileUrl) {
      if (fileUrl) {
        window.open(fileUrl)
      } else {
        this.$message.warning('file url nothingness!')
      }
    },

    /**
     * 删除文件
     *
     * @param {Number} id 文件ID
     */
    deleteFile(id) {
      this.$confirm('删除后客户将不能看到此文件, 且不可恢复, 确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let { code, message } = await API.deleteDocumentaryFileList(id)
          if (code === 10000) {
            this.$message.success(message)
            this.getDocumentaryFileList(false)
          } else {
            this.$message.error(message)
          }
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },

    /**
     * 每页显示数量发生改变时的回调
     *
     * @param size 每页显示数量
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getDocumentaryFileList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     *
     * @param current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getDocumentaryFileList(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-input {
  width: 200px;
  /deep/.el-input__inner {
    border-radius: 18px;
  }
}

a:link,
a:visited,
a:hover,
a:active {
  color: #99c41c;
  text-decoration: none;
}

.vertical {
  color: #f5f7f7;
  margin: 0 5px;
}
</style>
